export function formatCurrency(amount: number): string {
    const result = '$' + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    if (result.startsWith('$0.')) {
        return '$' + result.substr(2);
    }
    return result;
}

export function formatIntCurrency(amount: number): string {
    return formatCurrency(amount / 100);
}